import Vue from 'vue';
import App from './App.vue';

// Vuesax Component Framework
import Vuesax from 'vuesax';
import 'material-icons/iconfont/material-icons.css'; //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
import { initPixel } from './facebook-pixel';
Vue.use(Vuesax);

import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
Vue.use(Viewer);

import VueLocalStorage from 'vue-localstorage';
Vue.use(VueLocalStorage, {
  name: 'localStorage',
  bind: true //created computed members from your variable declarations
});

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: 'xgiacYizDGYYdtfvxLLaF7Q3PRd0j8Gp',
  cluster: 'eu',
  disableStats: true,
  authEndpoint: `/api/broadcasting/auth`,
  httpHost: process.env.VUE_APP_PUSHER_HTTPHOST,
  wsHost: process.env.VUE_APP_PUSHER_WSHOST,
  wssPort: process.env.VUE_APP_PUSHER_WSSPORT,
  wsPort: process.env.VUE_APP_PUSHER_WSPORT,
  forceTLS: process.env.VUE_APP_PUSHER_FORCETLS === 'true',
  encrypted: process.env.VUE_APP_PUSHER_ENCRYPTED === 'true',
  auth: {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  }
});

Vue.config.productionTip = false;

import VueNativeNotification from 'vue-native-notification';

Vue.use(VueNativeNotification, {
  requestOnNotify: true
});

// axios
import api from './api.js';
Vue.prototype.$api = api;

// Moment
import moment from 'moment';
Vue.filter('formatDateTime', function(value) {
  if (value) {
    return moment
      .utc(String(value))
      .local()
      .format('DD/MM/YYYY HH:mm:ss');
  }

  return value;
});

Vue.filter('formatDateTimeNoLocal', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm:ss');
  }

  return value;
});

Vue.filter('formatDateTimeNoSeconds', function(value) {
  if (value) {
    return moment
      .utc(String(value))
      .local()
      .format('DD/MM/YYYY HH:mm');
  }
});

Vue.filter('formatDateTimeNoSecondsNoLocal', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm');
  }
});

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment
      .utc(String(value))
      .local()
      .format('DD/MM/YYYY');
  }

  return value;
});

Vue.filter('formatTime', function(value) {
  if (value) {
    return moment
      .utc(String(value))
      .local()
      .format('HH:mm:ss');
  }

  return value;
});

Vue.filter('formatTimeNoLocal', function(value) {
  if (value) {
    return moment(String(value)).format('HH:mm:ss');
  }

  return value;
});

let getFirstBrowserLanguage = function() {
  let nav = window.navigator,
    browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
    i,
    language;

  // support for HTML 5.1 "navigator.languages"
  if (Array.isArray(nav.languages)) {
    for (i = 0; i < nav.languages.length; i++) {
      language = nav.languages[i];
      if (language && language.length) {
        return language;
      }
    }
  }

  // support for other well known properties in browsers
  for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
    language = nav[browserLanguagePropertyKeys[i]];
    if (language && language.length) {
      return language;
    }
  }

  return 'pt-BR';
};

Vue.filter('money', function(value, currencyCode) {
  const formatter = new Intl.NumberFormat(getFirstBrowserLanguage(), {
    style: 'currency',
    currency: currencyCode
  });

  return isNaN(value) ? '-' : formatter.format(value);
});

// Theme Configurations
import '../themeConfig.js';

// Globally Registered Components
import './globalComponents.js';

// Styles: SCSS
import './assets/scss/main.scss';

// Tailwind
import '@/assets/css/main.css';

// Vue Router
import router from './router';

// Vuex Store
import store from './store/store';

// i18n
import i18n from './i18n/i18n';

// Vuesax Admin Filters
import './filters/filters';

// Tour
import VueTour from 'vue-tour';
Vue.use(VueTour);
require('vue-tour/dist/vue-tour.css');

// VeeValidate
import pt_BR from 'vee-validate/dist/locale/pt_BR';
import VeeValidate, { Validator } from 'vee-validate';
Vue.use(VeeValidate, {
  locale: 'pt_BR'
});
Validator.localize('pt_BR', pt_BR);

// Map
import { LMap, LTileLayer, LMarker, LTooltip, LPolyline, LControl } from 'vue2-leaflet';
import LFreeDraw from 'vue2-leaflet-freedraw';
import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-tooltip', LTooltip);
Vue.component('l-polyline', LPolyline);
Vue.component('l-control', LControl);
Vue.component('l-freedraw', LFreeDraw);

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer';
Vue.use(VueHammer);

import VueCurrencyFilter from 'vue-currency-filter';
Vue.use(VueCurrencyFilter, {
  symbol: 'R$',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
});

import VueGtm from 'vue-gtm';
Vue.use(VueGtm, {
  id: ['GTM-564L84R'],
  defer: false,
  enabled: true,
  debug: process.env.NODE_ENV === 'development',
  loadScript: true,
  vueRouter: router,
  trackOnNextTick: true
});

// PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';

// VueClipboard
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

// Feather font icon
require('./assets/css/iconfont.css');

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

// EventBus
export const EventBus = new Vue();
Vue.prototype.$EventBus = EventBus;

Vue.config.productionTip = false;

initPixel('534687562382555');

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
